<template>
  <div>
    <div class="max-w-xl mx-auto px-4">
      <p
        class="text-left text-gray-900 mb-10 text-xl font-extrabold sm:text-3xl"
      >
        {{ $t('landing.faq.title') }}
      </p>
      <ul class="space-y-2">
        <li v-for="(faq, index) in faqList" :key="index">
          <button
            class="custom-card relative flex w-full items-center gap-2 p-4 text-left text-base font-medium md:text-base transition-colors"
            :class="
              openIndex === index
                ? 'bg-dark text-white'
                : 'bg-white text-gray-900 hover:bg-capino-light'
            "
            :aria-expanded="openIndex === index"
            @click="toggleFaq(index)"
          >
            <span class="flex-1">{{ faq.q }}</span>
            <BaseIcon
              :icon="openIndex === index ? 'minus' : 'plus'"
              class="ml-auto size-3 flex-shrink-0 transition-transform duration-200 ease-out"
            />
          </button>
          <div
            class="overflow-hidden px-4 text-gray-700 transition-all duration-300 ease-in-out"
            :style="
              openIndex === index
                ? 'max-height: 192px; opacity: 1'
                : 'max-height: 0px; opacity: 0'
            "
          >
            <div class="mr-4 space-y-1.5 pb-4 pt-3 leading-relaxed">
              <div
                v-if="faq.name === 'why-better'"
                v-html="$t('reborn.faq.whyBetterWithDemo')"
              />
              <div v-else v-html="faq.a" />
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import BaseIcon from '@/components/Base/BaseIcon.vue'

export default {
  name: 'LandingFAQ',

  components: { BaseIcon },

  data: () => ({
    openIndex: null
  }),

  computed: {
    faqList() {
      return [
        { q: this.$t('landing.faq.item1q'), a: this.$t('landing.faq.item1a') },
        { q: this.$t('landing.faq.item2q'), a: this.$t('landing.faq.item2a') },
        { q: this.$t('landing.faq.item3q'), a: this.$t('landing.faq.item3a') },
        { q: this.$t('landing.faq.item4q'), a: this.$t('landing.faq.item4a') },
        { q: this.$t('landing.faq.item5q'), a: this.$t('landing.faq.item5a') },
        { q: this.$t('landing.faq.item6q'), a: this.$t('landing.faq.item6a') },
        { q: this.$t('landing.faq.item7q'), a: this.$t('landing.faq.item7a') }
      ]
    }
  },

  methods: {
    toggleFaq(index) {
      if (this.openIndex === index) {
        this.openIndex = null
      } else {
        this.openIndex = index
      }
    }
  }
}
</script>

<style scoped>
.custom-card {
  border-radius: 8px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  border: 1px solid #e5e7eb;
}

.custom-card:hover {
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
}
</style>
